import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import { routes } from '../../assets/constants';
import { QuoteRequest, UpdateQuotePayload } from '../models/billing.model';

/**
 * Super-admin quote-request queue. Same auth-guarded helper as the rest of the
 * app — the stored super-admin token drives which backend strategy authorizes.
 */
export const useQuoteAdminApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);

  const listQuoteRequests = (status?: string): Promise<QuoteRequest[]> => {
    const url = status
      ? `${routes.billing.adminQuoteRequests}?status=${encodeURIComponent(status)}`
      : routes.billing.adminQuoteRequests;
    return sendAuthGuardedRequest(ApiMethod.GET, url) as Promise<QuoteRequest[]>;
  };

  // Update status, internal note, and/or quoted price.
  const updateQuote = (id: string, patch: UpdateQuotePayload): Promise<QuoteRequest> =>
    sendAuthGuardedRequest(ApiMethod.PUT, routes.billing.adminQuoteUpdate(id), patch) as Promise<QuoteRequest>;

  // Accept the quote → create a per-vendor Stripe product + custom price (marks it won).
  const setupQuoteBilling = (id: string): Promise<QuoteRequest> =>
    sendAuthGuardedRequest(ApiMethod.POST, routes.billing.adminQuoteSetupBilling(id)) as Promise<QuoteRequest>;

  return { listQuoteRequests, updateQuote, setupQuoteBilling };
};
